import { useState } from "react";
import { Text } from "@chakra-ui/react";
import CountDown from "react-countdown";

const useCountDownTimer = (date, resume = true) => {
  const [completed, setCompleted] = useState(false);

  const render = (props = {}) => {
    const innerRender = ({ minutes, seconds, completed }) => {
      if (completed)
        return (
          <Text
            fontSize="sm"
            color="red.400"
            textTransform="uppercase"
            {...props}
            {...props?._completed}
          >
            00m : 00s
          </Text>
        );
      return (
        <Text fontSize="sm" color="green.400" {...props}>
          {String(minutes).length < 2 ? "0" : ""}
          {minutes}m : {String(seconds).length < 2 ? "0" : ""}
          {seconds}s
        </Text>
      );
    };

    return (
      <CountDown
        onComplete={() => setCompleted(true)}
        date={date}
        renderer={innerRender}
      />
    );
  };

  return { Timer: render, completed };
};

export default useCountDownTimer;
